import axios from "axios";
import { isAuthenticated } from "./auth";

const API_BASE = `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/api`;

/**
 * Gọi /auth/refresh để lấy JWT + modules mới từ DB.
 * Dùng sau migration quyền / khi localStorage lệch với server.
 * @returns {Promise<boolean>} true nếu cập nhật thành công
 */
export async function refreshSessionPermissions() {
  if (!isAuthenticated()) return false;

  try {
    const refreshRes = await axios.post(
      `${API_BASE}/auth/refresh`,
      {},
      { withCredentials: true }
    );
    const newToken = refreshRes.data?.token;
    if (!newToken) return false;

    localStorage.setItem("token", newToken);
    if (Array.isArray(refreshRes.data.modules)) {
      localStorage.setItem("modules", JSON.stringify(refreshRes.data.modules));
    }
    return true;
  } catch {
    return false;
  }
}
